<template>
  <div class="h100vh-180">

    <ToolBarForTaskList ref="toolBarForTaskList"></ToolBarForTaskList>
    <GridForTaskListReal ref="gridForTaskListReal" @rowSelectedEmit="rowSelectedEmit"></GridForTaskListReal>

    <CustomDialog
      ref="addTaskPage"
      :element="dialogForAddTaskPage.element.addTaskElement"
      :styles="dialogForAddTaskPage.stylesSearch"
    >
      <template v-slot:dialog-content>
        <AddTaskDialog ref="addTaskDialog"></AddTaskDialog>
      </template>
    </CustomDialog>

    <CustomDialog
      ref="cmdConsolePage"
      :element="dialogForCmdConsolePage.element.addTaskElement"
      :styles="dialogForCmdConsolePage.stylesSearch"
    >
      <template v-slot:dialog-content>
        <CmdConsole ref="cmdConsole"></CmdConsole>
      </template>
    </CustomDialog>

    <CustomDialog
      ref="openQueryPage"
      :element="dialogForOpenQueryPage.element.addTaskElement"
      :styles="dialogForOpenQueryPage.stylesSearch"
    >
      <template v-slot:dialog-content>
        <GridForQueryData ref="gridForQueryData"></GridForQueryData>
      </template>
    </CustomDialog>

    <CustomDialog
      ref="detailTaskPage"
      :element="dialogFordetailTaskPage.element.addTaskElement"
      :styles="dialogFordetailTaskPage.stylesSearch"
    >
      <template v-slot:dialog-content>
        <DetailTask ref="detailTask"></DetailTask>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import pmSocket from '@/plugins/stompSock';
import commonUtil from './commonUtil';
import ToolBarForTaskList from './ToolBarForTaskList';
import GridForTaskListReal from './GridForTaskListReal';
import CustomDialog from '../../common/CustomDialog';
import AddTaskDialog from './dialog/AddTaskDialog';
import CmdConsole from './CmdConsole';
import GridForQueryData from './GridForQueryData';
import DetailTask from './DetailTask';
import { EventBus } from '../../../plugins/eventBus';
import Router from "../../../router";

export default {
  name: 'RealTaskList',
  components: {
    ToolBarForTaskList,
    GridForTaskListReal,
    CustomDialog,
    AddTaskDialog,
    CmdConsole,
    GridForQueryData,
    DetailTask
  },
  data() {
    return {
      // 添加实时任务
      dialogForAddTaskPage: {
        stylesSearch: {
          width: '850px',
          height: '662px',
          visible: false,
          model: true
        },
        element: {
          addTaskElement: {
            target: this.$refs.gridForTaskListReal,
            refName: 'addTaskElement',
            buttonGroup: [
              {
                click: this.closeAddTaskPage,
                buttonModel: { content: this.$t('Pm.cancel') }
              },
              {
                click: this.confirmAddTaskPage,
                buttonModel: {
                  content: this.$t('Pm.confirm'),
                  isPrimary: true
                }
              }
            ],
            isClose: true,
            title:this.$t('Pm.realtime_task_createTask')
          }
        }
      },
      // 控制台对话框
      dialogForCmdConsolePage: {
        stylesSearch: {
          width: '30%',
          height: '60%',
          visible: false,
          model: true
        },
        element: {
          addTaskElement: {
            target: this.$refs.cmdConsolePage,
            refName: 'addTaskElement',
            buttonGroup: [
              {
                click: this.confirmCmdConsolePage,
                buttonModel: {
                  content: this.$t('Pm.confirm'),
                  isPrimary: true
                }
              }
            ],
            isClose: false,
            title:this.$t('Pm.info')
          }
        }
      },
      // 数据查询页面
      dialogForOpenQueryPage: {
        stylesSearch: {
          width: '80%',
          height: '80%',
          visible: false,
          model: true
        },
        element: {
          addTaskElement: {
            target: '#app',
            refName: 'addTaskElement',
            buttonGroup: [
              {
                click: this.closeOpenQueryPage,
                buttonModel: { content: this.$t('Pm.cancel') }
              },
              {
                click: this.confirmOpenQueryPage,
                buttonModel: {
                  content: this.$t('Pm.confirm'),
                  isPrimary: true
                }
              }
            ],
            isClose: true,
            title:this.$t('Pm.queryInfo')
          }
        }
      },
      // 查看详细信息
      dialogFordetailTaskPage: {
        stylesSearch: {
          width: '60%',
          height: '80%',
          visible: false,
          model: true
        },
        element: {
          addTaskElement: {
            target: '#app',
            refName: 'addTaskElement',
            buttonGroup: [
              {
                click: this.closeDetailTaskPage,
                buttonModel: { content: this.$t('Pm.cancel') }
              },
              {
                click: this.confirmDetailTaskPage,
                buttonModel: {
                  content: this.$t('Pm.confirm'),
                  isPrimary: true
                }
              }
            ],
            isClose: true,
            title:this.$t('Pm.queryDetailInfo')
          }
        }
      },
      cmdExeFinshFlag: false, // 命令是否执行完毕
      timer1: undefined,
      timer2: undefined,
      payload: [
        { topic: '/user/#/PmTaskServer', clientId: '', callback: this.pmWebsocketLisener }
      ]
    };
  },
  methods: {
    methodList(operator) {
      switch (operator) {
        case 'add':
          this.addTaskPage();
          break;
        case 'start':
          this.startTask();
          break;
        case 'stop':
          this.stopTask();
          break;
        case 'delete':
          this.deleteTask();
          break;
        case 'export':
          this.exportTask();
          break;
        case 'consistency':
          this.checkConsistency();
          break;
        case 'sync':
          this.syncDownload();
          break;
        case 'detail':
          this.showDetailPage();
          break;
        case 'search':
          this.searchPage();
          break;
        default:
      }
    },
    // 创建实时任务
    addTaskPage() {
      this.$refs.addTaskPage.show();
      this.$refs.addTaskDialog.$refs.measureObjTree.loadSeatTreeById();
    },
    // 启动任务
    startTask: async function () {
      const url = '/lte/pm/currenttime/collect/openCollectPage.html';
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      const _this = this;
      let taskIndicators = undefined;

      await this.$axios
        .get(`${url}?taskId=${record.sysMeterTimelyTaskId}`, {})
        .then(response => {
          console.log('openCollectPage.html', response);

          if (response.status != 200) {
            EventBus.$emit('toast', { type: 'error', content: this.$t('Pm.failedToStart') });
            return;
          }
          taskIndicators = response.data.resultVal;
          if(!taskIndicators){
              EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
          }
        });

      if (taskIndicators) {
        await this.$axios
          .get(`/lte/pm/currenttime/taskmanagement/startTask.html?taskId=${record.sysMeterTimelyTaskId}`, {})
          .then(response => {
            console.log('startTask.html', response);
            this.$refs.gridForTaskListReal.getRealTaskTableData(1);
            if (response.status != 200) {
              EventBus.$emit('toast', { type: 'error', content: this.$t('Pm.failedToStart') });
              return;
            }
            let title = record.sysMeterTimelyTaskName;
            title = `${title}(${record.sysMeterTimelyTaskId})`; // title :measure + taskid;
            const params = {};
            params.title = title;
            params.taskId = record.sysMeterTimelyTaskId;
            params.measureIndicators = taskIndicators;
            params.taskIndicators = taskIndicators;
            // 重要的三个参数
            params.neTypeId = record.neTypeId;
            params.neVersionId = record.neVersionId;
            params.counterTypeId = record.counterTypeId;

            _this.$emit('createRealTaskAddTabEmit', params);
          });
      }
    },
    // 暂停任务
    stopTask() {
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      this.sendCmdAndRecieveData(
        '/lte/pm/currenttime/taskmanagement/stopTask',
        record
      );
    },
    // 删除任务
    deleteTask() {
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }
      if (record.sysMeterTimelyStatus === 2) {
        this.deleteUnavailableTask(record);
      } else {
        this.deleteavailableTask(record);
      }
    },
    // 导出
    exportTask() {
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      const taskId = record.sysMeterTimelyTaskId;
      let baseUrl = `${window.location.protocol}//${window.location.host}/`;

      baseUrl = `${baseUrl}/lte/pm/currenttime/collect/exportCollectData.html?systemId=1&taskId=${taskId}`;
      this.$axios.get('/lte/pm/query/testAjax').then((response) => {
        const result = response.data;
        if (result.errorCode == "SUCCESS"){
          window.open(baseUrl);
        } else {
          // 路由跳转到登录界面
          sessionStorage.removeItem('principal');
          localStorage.removeItem('mldn-session-id')
          Router.push({
            path: '/login'
          });
          Router.go(1);
        }
      });
    },
    // 一致性检查任务
    checkConsistency() {
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      const url = '/lte/pm/currenttime/taskmanagement/consistentCheckTask.html';
      this.sendCmdAndRecieveData(url, record);
    },
    // 同步下载
    syncDownload() {
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      const url = '/lte/pm/currenttime/taskmanagement/synchDownloadTask.html';
      this.sendCmdAndRecieveData(url, record);
    },
    // 查询任务详细信息
    showDetailPage() {
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      this.$refs.detailTaskPage.show();
      this.$refs.detailTask.detailTaskForm(record);
    },

    searchPage() {
      const record = this.$refs.gridForTaskListReal.getRowData();
      if (!record) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectDataPlease') });
        return;
      }

      const _this = this;
      let params = {};
      params.taskId = record.sysMeterTimelyTaskId;
      this.$axios
        .get(`/lte/pm/currenttime/collect/openQueryPage${commonUtil.analyticParameter(params)}`, {})
        .then(response => {
          params.taskIndicators = response.data.resultVal;
          params.neTypeId = record.neTypeId;

          _this.$refs.openQueryPage.show();
          _this.$refs.gridForQueryData.loadTableData(params);
        });
    },

    // 创建任务对话框的单击确认按钮事件
    confirmAddTaskPage: async function () {
      const _this = this;
      const params = this.$refs.addTaskDialog.pkgParams();

      // 如果pkgParams验证不通过时直接return，返回的结果就是undefined
      if (!params) {
        return;
      }

      const taskInfo = {
        neTypeId: params.measureObj.neTypeId,
        counterTypeId: params.measureObj.counterTypeId,
        neVersionId: params.measureObj.neVersionId,
      };

      //是否已经打开过一个标签窗口
      let exisWindow = _this.$parent.$parent.$parent.$parent.isTabAvailable();
      if(!exisWindow){
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.task_opened') });
        return;
      }

      // 查询用户是否已经订制过该任务
      let exisTask = undefined;

      await this.$axios
        .post('/lte/pm/currenttime/taskmanagement/isExistTaskAboutMeasure', taskInfo)
        .then(response => {
          console.log('isExistTaskAboutMeasure', response);
          exisTask = response.data.resultVal;
        });

      if (exisTask) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.task_started') });
        return;
      }

      let principal = JSON.parse(sessionStorage.getItem('principal'));
      params.username = principal.username;

      this.$axios
        .post('/lte/pm/currenttime/taskmanagement/createTask', params)
        .then(response => {
          if (response.data.resultVal) {
            const args = {};
            args.taskId = response.data.resultVal;
            args.title = (this._i18n.locale === 'zh')?params.measureObj.counterTypeNameCn:params.measureObj.counterTypeNameEn;
            args.title = `${args.title}(${args.taskId})`;
            args.measureIndicators = params.indicators;

            // 重要的三个参数
            args.neTypeId = params.measureObj.neTypeId;
            args.neVersionId = params.measureObj.neVersionId;
            args.counterTypeId = params.measureObj.counterTypeId;

            // 刷新一下页面
            this.$refs.gridForTaskListReal.getRealTaskTableData(1);

            _this.$emit('createRealTaskAddTabEmit', args);
          } else {
            EventBus.$emit('toast', { type: 'error', content: this.$t('Pm.failedToCreate') });
          }
        }).catch((error) => {
          // 请求失败处理
          console.error('error', error);
        });

      this.$refs.addTaskPage.close();
    },
    // 单击创建任务的关闭按钮
    closeAddTaskPage() {
      this.$refs.addTaskPage.close();
    },
    // 控制台对话框的单击确认按钮事件
    confirmCmdConsolePage() {
      if (!this.cmdExeFinshFlag) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.waitCommandFinish') });
        return;
      }
      this.$refs.cmdConsolePage.close();
      // 刷新一下页面
      this.$refs.gridForTaskListReal.getRealTaskTableData(1);
    },
    confirmOpenQueryPage() {
      this.$refs.openQueryPage.close();
    },
    closeOpenQueryPage() {
      this.$refs.openQueryPage.close();
    },
    // 查看详细页面确认按钮
    confirmDetailTaskPage() {
      this.$refs.detailTaskPage.close();
    },
    closeDetailTaskPage() {
      this.$refs.detailTaskPage.close();
    },
    transferMeasureObjChildren(msg) {
      this.$refs.gridForTaskListReal.getRealTaskTableData(1, msg);
    },
    transferNeChildren(msg) {
      this.$refs.gridForTaskListReal.getRealTaskTableData(2, msg);
    },
    // 单击表格数据时，决定哪些菜单按钮是可选的
    rowSelectedEmit(row) {
      this.$refs.toolBarForTaskList.setEnableItems(row);
    },
    // 其它状态下的删除
    deleteavailableTask(item) {
      this.sendCmdAndRecieveData(
        '/lte/pm/currenttime/taskmanagement/deleteTask', item
      );
    },
    // 失效状态下的删除
    deleteUnavailableTask(item) {
      const _this = this;
      const params = { taskId: item.sysMeterTimelyTaskId };
      this.$axios
        .get(
          `/lte/pm/currenttime/taskmanagement/deleteUnavailableTask.html${commonUtil.analyticParameter(params)}`,
          {}
        )
        .then(response => {
          if (response.data.resultVal > 0) {
            EventBus.$emit('toast', { type: 'success', content: this.$t('Pm.deleteSuccessfully') });
          } else {
            EventBus.$emit('toast', { type: 'error', content: this.$t('Pm.deleteFailed') });
          }
          this.$refs.gridForTaskListReal.getRealTaskTableData(1);
        });
    },
    // 发送命令并接收命令响应
    sendCmdAndRecieveData(url, item) {
      const _this = this;
      this.$refs.cmdConsolePage.show();
      this.cmdExeFinshFlag = false;
      // 变更确定按钮样式
      this.$refs.cmdConsole.buttonColorCss(false);
      // 建立websock同时订阅主题
      if (!pmSocket.socket || pmSocket.socket.readyState == 2 || pmSocket.socket.readyState == 3) {
        this.payload[0].clientId = item.sysMeterTimelyTaskId;
        pmSocket.init(this.payload);
      } else {
        console.log('subscribes', pmSocket.subscribes);
        if (pmSocket.subscribes[pmSocket.__buildSubscribeTopic(item.sysMeterTimelyTaskId, this.payload[0].topic)]) {
          // 主题已经存在无需特别处理
        } else {
          pmSocket.dynamicSubscribe(this.payload[0].topic, item.sysMeterTimelyTaskId, this.payload[0].callback);
        }
      }

      this.timer1 = window.setInterval(() => {
        _this.$refs.cmdConsole.appendConsoleMsg(_this.$t('Pm.taskInProgress'));
      }, 2000);

      this.delaySendCmd(url, { taskId: item.sysMeterTimelyTaskId });
    },
    /**
     * 组建接收的操作信息
     */
    buildRecvOperationInfo(response) {
      // 目前上报的信息是一个网元的完整操作信息，而不是产生一条上报一条
      for (var i = 0; i < response.messages.length; i++) {
        this.$refs.cmdConsole.appendConsoleMsg(`${response.messages[i].message}【${this.toDateTimeString(new Date(response.messages[i].time))}】`);
      }
      this.$refs.cmdConsole.appendConsoleMsg('---------------------------------------');
    },
    /**
     * @param responseSerialNum socket响应次数
     * @param neNum 任务操作的网元数
     */
    computeOperationProgress(responseSerialNum, neNum) {
      let progressValue = 0;
      if (responseSerialNum == 0) {
        // 第一次接受到服务端响应，设置进度为0
        progressValue = 0;
      } else {
        // 从第二次开始接受到的信息才是每个网元相关的信息
        if (responseSerialNum < neNum) {
          // 响应序列号小于该任务下的网元数
          progressValue = (100 / neNum) * responseSerialNum;
        } else {
          progressValue = 100;
        }
      }
      return progressValue;
    },
    // 延迟发送命令，直到websocket连接创建完毕
    /**
     * type CONNECTING = 0;
     * type OPEN = 1;
     * type CLOSING = 2;
     * type CLOSED = 3;
     */
    delaySendCmd(url, params) {
      const _this = this;
      this.timer2 = window.setInterval(function () {
        if (pmSocket.socket.readyState == 1) {
          clearInterval(_this.timer2);
          _this.sendParams(url, params);
        }
      }, 5000);
    },
    sendParams: async function (url, params) {
      const _this = this;
      await this.$axios.get(url + commonUtil.analyticParameter(params), {}).then(response => {
        console.log('pmSocket.socket.readyState', pmSocket.socket);
        _this.$refs.cmdConsole.appendConsoleMsg(response.data.errorString);
        // 变更确定按钮样式
        this.$refs.cmdConsole.buttonColorCss(true);
        this.cmdExeFinshFlag = true;
        clearInterval(_this.timer1);
      });
    },
    // websocket回调函数
    pmWebsocketLisener(response) {
      console.log('pmWebsocketLisener', response);
      // websocek响应转换成JavaScript对象
      const msg = JSON.parse(response.body);
      // 控制台打印结果
      this.buildRecvOperationInfo(msg);
    },
    // Date转日期时间字符串
    toDateTimeString(isMilli) {
      let month = isMilli.getMonth() + 1;
      let day = isMilli.getDate();
      if (month < 10) {
        month = `0${month}`;
      }
      if (day < 10) {
        day = `0${day}`;
      }

      return `${isMilli.getFullYear()}-${month}-${day} ${isMilli.getHours()}:${isMilli.getMinutes()}:${isMilli.getSeconds()}`;
      if (isMilli) {
        return `${this.padLeft(this.getFullYear(), 4, '0')}-${month}-${day} ${this.padLeft(this.getHours(), 2, '0')}:${this.padLeft(this.getMinutes(), 2, '0')}:${this.padLeft(this.getSeconds(), 2, '0')}:${this.padLeft(this.getMilliseconds(), 3, '0')}`;
      }

      return `${this.padLeft(this.getFullYear(), 4, '0')}-${month}-${day} ${this.padLeft(this.getHours(), 2, '0')}:${this.padLeft(this.getMinutes(), 2, '0')}:${this.padLeft(this.getSeconds(), 2, '0')}`;
    },
    /**
   * 左填充
   * @param str 待填充的字符串
   * @param len 需要填充到的长度
   * @param c   填充的字符
   */
    padLeft(str, len, c) {
      const padchar = (c && c.length > 0) ? c.charAt(0) : ' ';
      let resultVal = new String(str);
      while (resultVal.length < len) {
        resultVal = padchar + resultVal;
      }
      return resultVal;
    },
    // 刷新任务列表
    refreshGridForTaskListReal() {
      this.$refs.gridForTaskListReal.getRealTaskTableData(1);
    }
  }
};
</script>

<style>
</style>
